import { ADVISOR_OBJECT_KEY, getSessionStorageItem } from './sessionStorage';

// wrappers for http requests
// will include user access token by default

export const httpRequest = {
  get,
  post,
  put
}

function get(url) {
  const options = {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${getSessionStorageItem(ADVISOR_OBJECT_KEY).userToken}`,
    },
  }

  return fetch(url, options).then(handleResponse);
}

function post(url, body, submissionType = '') {
  const options = {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${getSessionStorageItem(ADVISOR_OBJECT_KEY).userToken}`,
      'Content-Type': 'application/json',
      'SUBMISSION_TYPE': submissionType
    },
    body: body ? JSON.stringify(body) : ''
  }

  return fetch(url, options).then(handleResponse);
}

function put(url, body) {
  const options = {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${getSessionStorageItem(ADVISOR_OBJECT_KEY).userToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }

  return fetch(url, options).then(handleResponse);
}

// non-exported helpers

const isJsonParsable = (text) => {
  try {
      JSON.parse(text);
  } catch (e) {
      return false;
  }
  return true;
}

function handleResponse(response) {
  return response.text().then(text => {

    if (!isJsonParsable(text) && !response.ok) {

      checkStatusCode(response);
      return Promise.reject('Invalid response message');
    }

    const data = text && JSON.parse(text);

    if (!response.ok) {
      const error = (data && data.message) || (data && data.messages && data.messages.map(a=>a.message).join(" ")) ||response.statusText;

      checkStatusCode(response);
      return Promise.reject(error);
    }

    return Promise.resolve(data);
  });
}

function checkStatusCode(response) {
    switch (response.status) {
        case 401:
        case 403:
            break;
        default:
            break;
    }
}



// WEBPACK FOOTER //
// ./src/httpRequest.js